import type {RouteRecordRaw} from 'vue-router';
import {propositionGuard} from '@/router/guards/propositionGuard';

export const packagingsRoutes: RouteRecordRaw[] = [
  {
    name: 'packagings',
    path: '/webshop/orders',
    component: () => import('@/views/PackagingOverview/PackagingOverview.vue'),
    beforeEnter: (to, from) => {
      propositionGuard(to, from, (proposition) => {
        return proposition.applications.webshop.enabled;
      });
    },
    meta: {
      permissions: ['accountSelectOrder'],
      title: (t) => t('webshop.title', 2),
    },
    children: [
      {
        name: 'packaging-overview-detail',
        path: ':id',
        props: true,
        components: {
          packagingOverview: () => import('@/views/PackagingOverview/PackagingOverviewDetail.vue'),
        },
        meta: {
          permissions: ['accountSelectOrder'],
        },
      },
    ],
  },
];
